/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "teamapp": {
        "nested": {
          "ui": {
            "nested": {
              "Number": {
                "fields": {
                  "amount": {
                    "type": "double",
                    "id": 1,
                    "rule": "required"
                  },
                  "format": {
                    "type": "squareup.teamapp.ui.Number.Format",
                    "id": 2,
                    "rule": "optional"
                  },
                  "maxFractionalDigits": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Format": {
                    "values": {
                      "NONE": 0,
                      "DECIMAL": 1,
                      "PERCENT": 2
                    }
                  }
                }
              },
              "Duration": {
                "fields": {
                  "duration": {
                    "type": "string",
                    "id": 1,
                    "rule": "required"
                  },
                  "allowedUnits": {
                    "type": "squareup.teamapp.ui.Duration.Unit",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "maximumUnitCount": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Unit": {
                    "values": {
                      "SECOND": 0,
                      "MINUTE": 1,
                      "HOUR": 2,
                      "DAY": 3,
                      "MONTH": 4,
                      "YEAR": 5
                    }
                  }
                }
              },
              "ParameterizedTextParameters": {
                "fields": {
                  "numberParameters": {
                    "type": "squareup.teamapp.ui.Number",
                    "id": 1,
                    "keyType": "string"
                  },
                  "moneyParameters": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "keyType": "string"
                  },
                  "durationParameters": {
                    "type": "squareup.teamapp.ui.Duration",
                    "id": 3,
                    "keyType": "string"
                  }
                }
              },
              "ParameterizedText": {
                "fields": {
                  "text": {
                    "type": "string",
                    "id": 1,
                    "rule": "required"
                  },
                  "parameters": {
                    "type": "squareup.teamapp.ui.ParameterizedTextParameters",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fallbackParameters": {
                    "type": "string",
                    "id": 3,
                    "keyType": "string"
                  },
                  "fallbackText": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "Link": {
                "fields": {
                  "webUrl": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "webUrlHidesNavigation": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "deepLink": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "Button": {
                "fields": {
                  "title": {
                    "type": "squareup.teamapp.ui.ParameterizedText",
                    "id": 1,
                    "rule": "optional"
                  },
                  "link": {
                    "type": "squareup.teamapp.ui.Link",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Row": {
                "fields": {
                  "title": {
                    "type": "squareup.teamapp.ui.ParameterizedText",
                    "id": 1,
                    "rule": "optional"
                  },
                  "value": {
                    "type": "squareup.teamapp.ui.ParameterizedText",
                    "id": 2,
                    "rule": "optional"
                  },
                  "link": {
                    "type": "squareup.teamapp.ui.Link",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.teamapp?.nested?.ui?.nested?.Number && !$root.nested?.squareup?.nested?.teamapp?.nested?.ui?.nested?.Number?.nested?.Format && !$root.nested?.squareup?.nested?.teamapp?.nested?.ui?.nested?.Duration && !$root.nested?.squareup?.nested?.teamapp?.nested?.ui?.nested?.Duration?.nested?.Unit && !$root.nested?.squareup?.nested?.teamapp?.nested?.ui?.nested?.ParameterizedTextParameters && !$root.nested?.squareup?.nested?.teamapp?.nested?.ui?.nested?.ParameterizedText && !$root.nested?.squareup?.nested?.teamapp?.nested?.ui?.nested?.Link && !$root.nested?.squareup?.nested?.teamapp?.nested?.ui?.nested?.Button && !$root.nested?.squareup?.nested?.teamapp?.nested?.ui?.nested?.Row) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Number @ squareup/teamapp/ui/models.proto at 11:1
 */
export const Number = $root.lookupType('squareup.teamapp.ui.Number');
fixType(Number, {
  format: {
    required: true
  }
});
Builder.createAndAttachToType(Number);
/**
 * SOURCE Format @ squareup/teamapp/ui/models.proto at 12:5
 */
Number.Format = $root.lookupEnum('squareup.teamapp.ui.Number.Format').values;
/**
 * SOURCE Duration @ squareup/teamapp/ui/models.proto at 23:1
 */
export const Duration = $root.lookupType('squareup.teamapp.ui.Duration');
fixType(Duration);
Builder.createAndAttachToType(Duration);
/**
 * SOURCE Unit @ squareup/teamapp/ui/models.proto at 24:5
 */
Duration.Unit = $root.lookupEnum('squareup.teamapp.ui.Duration.Unit').values;
/**
 * SOURCE ParameterizedTextParameters @ squareup/teamapp/ui/models.proto at 38:1
 */
export const ParameterizedTextParameters = $root.lookupType('squareup.teamapp.ui.ParameterizedTextParameters');
fixType(ParameterizedTextParameters);
Builder.createAndAttachToType(ParameterizedTextParameters);
/**
 * SOURCE ParameterizedText @ squareup/teamapp/ui/models.proto at 44:1
 */
export const ParameterizedText = $root.lookupType('squareup.teamapp.ui.ParameterizedText');
fixType(ParameterizedText);
Builder.createAndAttachToType(ParameterizedText);
/**
 * SOURCE Link @ squareup/teamapp/ui/models.proto at 51:1
 */
export const Link = $root.lookupType('squareup.teamapp.ui.Link');
fixType(Link);
Builder.createAndAttachToType(Link);
/**
 * SOURCE Button @ squareup/teamapp/ui/models.proto at 57:1
 */
export const Button = $root.lookupType('squareup.teamapp.ui.Button');
fixType(Button);
Builder.createAndAttachToType(Button);
/**
 * SOURCE Row @ squareup/teamapp/ui/models.proto at 62:1
 */
export const Row = $root.lookupType('squareup.teamapp.ui.Row');
fixType(Row);
Builder.createAndAttachToType(Row);